<template>
  <v-dialog
      title="Add Comment"
      :visible.sync="dialogVisible"
      width="500px"
      :scrollbar="false"
      @closed="onClosed"
  >
    <el-form ref="form" :model="form" :rules="formRules">
      <el-form-item prop="comment" label="Comment">
        <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 6 }"
            v-model="form.comment"
            :maxlength="100"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleAddAdandam"> Submit</el-button>
      <el-button @click="dialogVisible = false"> Cancel</el-button>
    </div>
  </v-dialog>
</template>

<script>
import {trimValidate} from "../../utils/validator";

export default {
  name: "AddAdandamDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true,
    },
    data: Object,
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        comment: "",
      },
      formRules: {
        comment: [
          {
            required: true,
            validator: trimValidate("Please input comment"),
            tigger: "bulr",
          },
        ],
      },
    };
  },
  watch: {
    visible(value) {
      this.dialogVisible = value;
    },
  },
  methods: {
    handleAddAdandam() {
      if (!this.data) {
        return
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return
        }
        const {MessageHeadID, OneTimeRequest} = this.data;
        let url = "/push/adandam";
        let data = {
          messageHeadId: MessageHeadID
        }
        if (OneTimeRequest === 3) {
          url = "/quickPush/adandam";
          data = {
            PushContentID: MessageHeadID
          }
        }
        this.axios.post(url, {...data, comment: this.form.comment.trim()}).then(({code, msg}) => {
          if (code === 200) {
            this.$message.success("Add comment successfully");
            this.dialogVisible = false;
            this.$emit("success");
          } else {
            this.$message.error(msg);
          }
        });
      });
    },
    onClosed() {
      this.$refs.form.resetFields();
      this.$emit("update:visible", false);
      this.$emit("update:data", null);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-form {
  width: 100%;
}

.dialog-footer {
  text-align: center;
}
</style>
